export function AuthData(){
    let data = localStorage.getItem('userData');
    return JSON.parse(data);
}

export function commission(){
    let data = localStorage.getItem('com');
    //console.log(data);
    return JSON.parse(data);
}

export const isLoginCheck = () => {
    if (localStorage.getItem('userData')) return true;
    return false;
}


// WEBPACK FOOTER //
// ./src/Services/Authdata.js